import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { publicHead, publicSite } from '../lib/public-site';

// Keep client-side navigation consistent with the HTML served to non-JavaScript crawlers.
export function PublicMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (![new URL(publicSite.origin).hostname, 'sloelabs.com', 'localhost', '127.0.0.1'].includes(location.hostname)) return;
    document.head.querySelectorAll('[data-public-metadata]').forEach(node => node.remove());
    const markup = publicHead(pathname.replace(/\/$/, '') || '/');
    if (!markup) return;
    const template = document.createElement('template');
    template.innerHTML = markup;
    document.head.append(template.content);
  }, [pathname]);
  return null;
}
